import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllControledePatrimonioInspecaoUseCase } from "../../../presentation/useCases/read/get_all_controlede_patrimonio_inspecao_use_case";
import { InspecaoMaquinaEquipLista } from "../../models/inspecao_maquina_equip_lista";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

export class GetAllControledePatrimonioInspecaoUseCase
  extends BasePaginatedUseCase<InspecaoMaquinaEquipLista>
  implements IGetAllControledePatrimonioInspecaoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {
    super();
  }

  async getAllControledePatrimonioInspecao(
    idControleCentroCusto: number | undefined,
    maquinaEquip: number[] | null,
    page: number,
    rowsPerPage: number,
    dataEntradaDe?: Date | null,
    dataEntradaAte?: Date | null,
    codigo?: string | null
  ): Promise<void> {
    if (idControleCentroCusto === undefined) throw new Error("Falha ao obter id de controle de centro de custo.");

    const response = await this.repository.getControledePatrimonioInspecaoList(
      idControleCentroCusto,
      maquinaEquip,
      page,
      rowsPerPage,
      dataEntradaDe,
      dataEntradaAte,
      codigo
    );

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
